import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { ValidationResult } from "@foundation/foundation.enums";
import { IManualValidationCheckCategory } from "@foundation/foundation.interfaces";
import { ManualDeviceValidationCheckService, ManualTests } from "@foundation/_services/manual-device-validation-check.service";
import "./manual-test-container.component.scss";

@Component({
    selector: "manual-test-container",
    template: require('./manual-test-container.component.html')
})
export class ManualTestContainerComponent implements OnChanges {

    // bindings
    @Input() categories: IManualValidationCheckCategory

    @Output() onValidationComplete: EventEmitter<ValidationResult> = new EventEmitter();

    // internal
    faultRecorded: boolean = false;

    constructor(
        private readonly manualDeviceValidationCheckService: ManualDeviceValidationCheckService) {
    }   

    ngOnInit(): void {
    }

    ngOnChanges(): void {
        this.validateCompletion();
    }

    onFaultRecordChecked(event: any): void {
        this.faultRecorded = event;
        this.validateCompletion();

    }

    onFaultTextChanged(): void {
        this.validateCompletion();
    }

    onTestChecked(event: any, test: ManualTests): void {
        this.categories.checks.find(check => check.test == test).testConfirmation = event == true ? ValidationResult.Pass : ValidationResult.Warning;

        this.validateCompletion();
    }

     // --------------------

    private validateCompletion(): void {
        let verified = true;

        this.categories.checks.forEach(check => {
            if (check.testConfirmation != ValidationResult.Pass) {
                verified = false;
            }
        });
        console.log(verified);

        console.log(this.categories.faultComments);
        if (verified || (this.faultRecorded && this.categories.faultComments)) {
            console.log(this.categories.faultComments);
            this.onValidationComplete.emit(ValidationResult.Pass);
        } else {
            this.onValidationComplete.emit(ValidationResult.Fail);
        }
    }
}
